module.exports = __webpack_public_path__ + "img/product-p2.9629d093.jpg";